import { render, staticRenderFns } from "./DocEditCallback.vue?vue&type=template&id=1c9767fa&"
import script from "./DocEditCallback.vue?vue&type=script&lang=ts&"
export * from "./DocEditCallback.vue?vue&type=script&lang=ts&"
import style0 from "./DocEditCallback.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports